import { ProductState, ProductStateItem } from '@/lib/types/store/products'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: ProductState = {
  items: [] as ProductStateItem[],
  selectedProduct: null as ProductStateItem | null,
  loading: false,
  error: null,
  filterParams: null as Record<string, unknown> | null
}

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<ProductStateItem[]>) => {
      state.items = action.payload
      state.loading = false
      state.error = null
    },
    updateProduct: (state, action: PayloadAction<ProductStateItem>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id)
      if (index !== -1) {
        state.items[index] = action.payload
      } else {
        state.items.push(action.payload)
      }
      state.loading = false
      state.error = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
    setSelectedProduct: (state, action: PayloadAction<ProductStateItem>) => {
      state.selectedProduct = action.payload
    },
    setFilterParams: (state, action: PayloadAction<Record<string, unknown>>) => {
      state.filterParams = action.payload
    },
  },
})

export const {
  setProducts,
  updateProduct,
  setFilterParams,
  setLoading,
  setError,
  setSelectedProduct,
} = productsSlice.actions

export default productsSlice.reducer
